<!--
<jim-file-manager><nb-icon icon="folder-outline"></nb-icon>{{ 'menu.file-manager' | translate }}</jim-file-manager>

-->
  
<nb-menu [items]="menus"></nb-menu>



